// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".News-cls1__c9426d9410402af25294{/*!*/}.News-cls2__ab18ac3446835d8002e2{padding-top:16px;margin:0 16px;border-top:1px solid #dddde2;border-top:1px solid var(--stroke-light, #dddde2)}.News-cls2__ab18ac3446835d8002e2.News-variant-dense___046b3c66106705dcfb4{border-top:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "News-cls1__c9426d9410402af25294",
	"cls2": "News-cls2__ab18ac3446835d8002e2 News-cls1__c9426d9410402af25294",
	"variant-dense": "News-variant-dense___046b3c66106705dcfb4"
};
export default ___CSS_LOADER_EXPORT___;
